import React, { useContext, useState } from 'react';
import Image from 'next/image';
import { Field, Form } from 'react-final-form';
import AppBar from '@material-ui/core/AppBar/AppBar';
import Toolbar from '@material-ui/core/Toolbar/Toolbar';

import { TextAreaForm } from '@gjc/classi-react-commons/ClassiTextArea';
import Button from '@gjc/classi-react-commons/ClassiButton';
import { StyledCheckbox } from '@gjc/classi-react-commons/ClassiCheckbox';
import { SelectTagForm } from '@gjc/classi-react-commons/ClassiSelect/select';
import { InputForm } from '@gjc/classi-react-commons/ClassiInput/input';

import TelefoneEscondido from 'components/TelefoneEscondido';
import {
    BotaoRetornar,
    FormContatoHeader,
    FormContatoHeaderTexto,
    LeadBoxFechadoContainer,
} from './fechado-styled';
import useImoveis from '../../../api/imoveis';
import Loading from '../../Loading/Loading';
import InfoAnunciante from '../InfoAnunciante';
import Feedback from '../../Feedback';
import { composeValidators, options, required } from '../leadBoxCommons';
import { SetaLeftBlueSVG, SetaLeftWhiteSVG } from '../../../utils/icons';
import { TextButton } from '../../../styles/theme-styled';
import { DialogOpenContext } from '../../MobileBottomBarAnuncio/mobileBottomBarAnuncioContext';
import { whatsappUrlForSharingAdvertising } from 'utils/whatsappUrl';

const Fechado = ({ anunciante, idAnuncio, onDialog, tituloAnuncio }) => {
    const whatsappUrl = whatsappUrlForSharingAdvertising(
        anunciante?.whatsApp,
        tituloAnuncio
    );

    const { setDialogOpen } = useContext(DialogOpenContext);

    const [maisInformacoes, setMaisInformacoes] = useState(false);
    const [checkBoxTermos, setCheckBoxTemos] = useState(false);
    const [mask, setMask] = useState('');
    const [placeholder, setPlaceholder] = useState('');
    const [validadores, setValidadores] = useState([required]);
    const { sendMessage } = useImoveis();
    const [showFeedback, setShowFeedback] = useState(false);
    const [feedbackSuccess, setFeedbackSuccess] = useState(true);

    const onSubmit = async (mensagem) => {
        if (mensagem.tipoContatoMensagem) {
            mensagem.tipoContatoMensagem = mensagem.tipoContatoMensagem.valor;
        }

        if (mensagem.tipoContatoMensagem === 'EMAIL') {
            mensagem.email = mensagem.contato;
        } else {
            mensagem.telefone = mensagem.contato;
        }

        mensagem.idAnuncio = idAnuncio;

        return sendMessage(mensagem)
            .then(() => {
                setShowFeedback(true);
            })
            .catch(() => {
                setFeedbackSuccess(false);
                setShowFeedback(true);
            });
    };

    const handleCheckBox = () => {
        if (checkBoxTermos) {
            setCheckBoxTemos(false);
        } else {
            setCheckBoxTemos(true);
        }
    };

    // Função utilizada apenas em celulares
    const toolbarBackPressed = () => {
        if (maisInformacoes === false) {
            setDialogOpen(false);
        }

        setMaisInformacoes(false);
    };


    // Caso o LeadBox fechado esteja em um Dialog a borda e o header devem sumir
    return (
        <>
            {onDialog && (
                <AppBar
                    position={'sticky'}
                    style={{
                        background: '#30bcd5',
                    }}
                >
                    <Toolbar>
                        <TextButton onClick={() => toolbarBackPressed()}>
                            <Image
                                src={SetaLeftWhiteSVG}
                                alt="seta para esquerda"
                                width={24}
                                height={24}
                            />
                        </TextButton>

                        <h4>Contato anunciante</h4>
                    </Toolbar>
                </AppBar>
            )}
            <LeadBoxFechadoContainer onDialog={onDialog}>
                {maisInformacoes ? (
                    <>
                        {showFeedback ? (
                            <>
                                {onDialog && <InfoAnunciante {...anunciante} />}
                                <Feedback success={feedbackSuccess} />
                                <Button
                                    onClick={() => setShowFeedback(false)}
                                    appearance={'primaryOutline'}
                                    label={'Voltar'}
                                    style={{
                                        marginLeft: 0,
                                        marginRight: 0,
                                        width: '100%',
                                    }}
                                />
                            </>
                        ) : (
                            <Form
                                onSubmit={onSubmit}
                                decorators={[]}
                                render={({
                                    handleSubmit,
                                    form,
                                    submitting,
                                    values,
                                }) => {
                                    const handleContatoChange = (
                                        tipoContatoMensagem
                                    ) => {
                                        form.change('contato', null);
                                        setMask(tipoContatoMensagem.mask);
                                        setPlaceholder(
                                            tipoContatoMensagem.placeholder
                                        );
                                        setValidadores(
                                            tipoContatoMensagem.validadores
                                        );
                                    };

                                    return (
                                        <>
                                            <FormContatoHeader
                                                onDialog={onDialog}
                                            >
                                                <BotaoRetornar
                                                    onClick={() =>
                                                        setMaisInformacoes(
                                                            false
                                                        )
                                                    }
                                                >
                                                    <Image
                                                        src={SetaLeftBlueSVG}
                                                        alt="seta para esquerda"
                                                        width={24}
                                                        height={24}
                                                    />
                                                </BotaoRetornar>

                                                <FormContatoHeaderTexto>
                                                    Meus dados para contato
                                                </FormContatoHeaderTexto>
                                            </FormContatoHeader>

                                            <form
                                                onSubmit={(event) =>
                                                    handleSubmit(event)
                                                }
                                            >
                                                {onDialog && (
                                                    <InfoAnunciante
                                                        {...anunciante}
                                                    />
                                                )}

                                                <Field
                                                    name="nome"
                                                    component={InputForm}
                                                    isrequired
                                                    title="Nome"
                                                    containerstyle={{
                                                        marginBottom: '20px',
                                                    }}
                                                    validate={required}
                                                />

                                                <Field
                                                    id="tipoContatoMensagem"
                                                    name="tipoContatoMensagem"
                                                    title="Quero que entre em contato via"
                                                    options={options}
                                                    component={SelectTagForm}
                                                    getOptionValue={(item) =>
                                                        item.valor
                                                    }
                                                    getOptionLabel={(item) =>
                                                        item.descricao
                                                    }
                                                    onChange={
                                                        handleContatoChange
                                                    }
                                                    containerstyle={{
                                                        marginBottom: '20px',
                                                    }}
                                                    validate={required}
                                                    isrequired={true}
                                                />

                                                <Field
                                                    name={'contato'}
                                                    title="Contato"
                                                    component={InputForm}
                                                    mask={mask}
                                                    placeholder={placeholder}
                                                    disabled={
                                                        !values.tipoContatoMensagem
                                                    }
                                                    containerstyle={{
                                                        marginBottom: '20px',
                                                    }}
                                                    validate={composeValidators(
                                                        ...validadores
                                                    )}
                                                    isrequired={true}
                                                />
                                                <Field
                                                    name="texto"
                                                    component={TextAreaForm}
                                                    isrequired
                                                    title="Mensagem"
                                                    containerstyle={{
                                                        marginBottom: '20px',
                                                    }}
                                                    validate={required}
                                                />
                                                <div
                                                    style={{ margin: '10px 0' }}
                                                >
                                                    <Field
                                                        name={'aceitaTermos'}
                                                        component={
                                                            StyledCheckbox
                                                        }
                                                        checked={checkBoxTermos}
                                                        onChange={() => {
                                                            handleCheckBox();
                                                        }}
                                                        text="Aceito os Termos de uso e Política de privacidade para contatar os próximos anunciantes e afirmo ter mais de 18 anos."
                                                        color="primary"
                                                    />
                                                </div>

                                                <Button
                                                    className="entrar_contato"
                                                    label={'Enviar'}
                                                    appearance={'primary'}
                                                    disabled={!checkBoxTermos}
                                                    style={
                                                        checkBoxTermos
                                                            ? {
                                                                  backgroundColor:
                                                                      '#ffa000',
                                                                  marginLeft: 0,
                                                                  marginRight: 0,
                                                                  border: 'none',
                                                                  width: '100%',
                                                              }
                                                            : {
                                                                  backgroundColor:
                                                                      '#BBBBBB',
                                                                  marginLeft: 0,
                                                                  marginRight: 0,
                                                                  border: 'none',
                                                                  width: '100%',
                                                                  cursor: 'default',
                                                                  boxShadow:
                                                                      '0 0 0 0 rgba(0, 0, 0, 0)',
                                                              }
                                                    }
                                                />

                                                {submitting && <Loading />}
                                            </form>
                                        </>
                                    );
                                }}
                            />
                        )}
                    </>
                ) : (
                    <>
                        <InfoAnunciante {...anunciante} />
                        {anunciante?.whatsApp && (
                            <a
                                href={whatsappUrl}
                                target="_blank"
                                passHref
                                rel="noreferrer"
                                className="whatsapp"
                            >
                                <Button
                                    appearance={'primary'}
                                    label={'Contato via WhatsApp'}
                                    style={{
                                        marginLeft: 0,
                                        marginRight: 0,
                                        backgroundColor: '#25d366',
                                        border: 'none',
                                        width: '100%',
                                    }}
                                />
                            </a>
                        )}
                        <Button
                            onClick={() => setMaisInformacoes(true)}
                            appearance={'primaryOutline'}
                            label={'Quero mais informações'}
                            style={{
                                marginLeft: 0,
                                marginRight: 0,
                                width: '100%',
                            }}
                        />
                        <TelefoneEscondido
                            telefone={anunciante?.telefones}
                        />
                    </>
                )}
            </LeadBoxFechadoContainer>
        </>
    );
};

export default Fechado;
